import { render, staticRenderFns } from "./BvFooter.vue?vue&type=template&id=21b99831&"
import script from "./BvFooter.vue?vue&type=script&lang=ts&"
export * from "./BvFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports